import api from "./Api";

class CidadeService {
  GetCidadeOData(payload) {
    return api.get("/OData/Cidade" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CidadeService();
